// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EventSponsorSummary{align-items:center;border:1px solid #f5f5f5;display:flex;justify-content:center;position:relative}.EventSponsorSummary img.sponsor-image{height:auto;max-height:128px;width:auto}.EventSponsorSummary .no-image-display{background-position:50% 50%;background-repeat:no-repeat;background-size:contain;bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
